import { render, staticRenderFns } from "./LogosSingleAnswer.vue?vue&type=template&id=68ddc38a&scoped=true&lang=html&"
import script from "./LogosSingleAnswer.vue?vue&type=script&lang=coffee&"
export * from "./LogosSingleAnswer.vue?vue&type=script&lang=coffee&"
import style0 from "./LogosSingleAnswer.vue?vue&type=style&index=0&id=68ddc38a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ddc38a",
  null
  
)

component.options.__file = "LogosSingleAnswer.vue"
export default component.exports